module.exports = __webpack_public_path__ + "static/media/savvy-ipfs-companion.98fed2dc.svg";